import { Event } from '../Event'
import { Identity } from '../../constants'

export interface ExpertRemovedRecommendedItemEventProperties {
  input_sellable_id: string
  recommended_sellable_id: string
}

export class ExpertRemovedRecommendedItemEvent extends Event<
  ExpertRemovedRecommendedItemEventProperties
> {
  static displayName = 'Expert Removed Recommended Item'

  static allowedIdentities = [Identity.BusinessUser]
}
